/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-16 20:14:00
 */

 import * as Vue from "vue-tsx-support";
 import {Component, Prop} from 'vue-property-decorator'
 import "vue-tsx-support/enable-check"
 import Modal from "src/types/iview/Modal";
 import Button from "src/types/iview/Button";
 import Input from "src/types/iview/Input";
 import {Toast} from "src/util/toast";
 import {modalFactory} from "src/util/vueExtend";
 import EnumOperates from "src/enums/enumOperates";
 import HexFileApi, { HexFileDOI } from './api/hexFileApi';
 import RegexCheck from 'src/util/regexCheck';
import { component } from 'vue-tsx-support';
import Upload from 'src/types/iview/Upload';
import { createNamespace } from 'src/util/bem';
import LocalStore from 'src/util/LocalStore';

export namespace HexFileOperateVOI {
	export interface PropsI {
		operate: string
        current?: HexFileDOI.RowDataI
        superior: {id: number, name: string}
		saveSuccess? (): void
		cancel? (): void
	}
}

@Component
class HexFilesOperateModal extends Vue.Component<any>{
    @Prop({
		type: Function
	})
	cancel!: () => void

	@Prop({
		type: Object
	})
    current!: HexFileDOI.RowDataI
    
    @Prop({
		type: Object
	})
	superior!:{id: number, name: string}

	@Prop({
		type: String
	})
	operate!: string

	@Prop({
		type: Function
	})
	saveSuccess!: () => void

	visible: boolean = false

	loading: boolean = false

    uploading: boolean = false;

    formData: HexFileDOI.OperateParamsIs = {
        name: '',
        parent_id: null,
        file_url: '',
        file_version:'',
	}

    rules: any = {}

	close () {
		this.cancel && this.cancel()
		this.closeModal()
	}

	closeModal() {
		this.visible = false
		this.$emit('close', false)
	}

    async save (){
        if(!await this.$validate('formValidate')) {
			return
		}
		let res
		this.loading = true
		let params:HexFileDOI.OperateParamsI = {
			...this.formData,
		}
		res = await HexFileApi.addFile(params)
		this.loading = false
		let {code} = res
		if (code === 0) {
			Toast.success("添加文件成功")
			this.saveSuccess()
			this.closeModal()
		}
    }

    mounted() {
        this.formData.parent_id = this.superior.id
    }

    uploadSuccess(res) {
        Toast.success(res.message)
        this.uploading = false;
        if(res.code===0) {
            this.formData.file_url=res.data.url
            this.formData.name = res.data.name
        } 
    }

    get headers() {
        let headers:any = {}
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        headers.access_token = userInfo.access_token || '';
        headers.OperationPlatform = 'Web';
        return headers
    }

    render (h) {
		return (
			<Modal
				title={"新增文件"}
				width="500"
				v-model={this.visible}
				mask-closable={false}
				on-on-cancel={this.close}
			>
				<i-form ref="formValidate"  labelWidth={100} model={this.formData} rules={this.rules} style="width:80%">
					<form-item label="上级目录"  >
						{this.superior.name}
					</form-item>
                    <form-item label="上传文件"  style="display: inline-block;width:90%">
                        <Upload
                            class="lims-file-upload"
                            action="/monitor/files/upload"
                            show-upload-list={false}
                            name="accessory"
                            headers={this.headers}
                            on-success={this.uploadSuccess}
                            before-upload={() => {
                                this.uploading = true;
                            }}
                        >
                        <Button class={createNamespace('upload-btn')} icon="ios-cloud-upload-outline" loading={this.uploading}>上传hex文件</Button>
                        </Upload>
                    </form-item>
                    <form-item label="文件版本说明"  prop="file_version" >
                        <Input placeholder="请输入" v-model={this.formData.file_version} type="textarea"/>
                    </form-item>
				</i-form>
				<div slot="footer">
					<Button type="primary" ghost on-click={this.close}>取消</Button>
					<Button type="primary" on-click={this.save} loading={this.loading}>保存</Button>
				</div>
			</Modal>
		);
	}
}

export default function alertHexFilesOperateModal (operate: string,superior: {id: number, name: string}, current?: HexFileDOI.RowDataI): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<HexFileOperateVOI.PropsI>(HexFilesOperateModal)({
            current,
            operate,
            superior,
            saveSuccess () {
                resolve(true)
            },
            cancel () {
                resolve(false)
            }
        })
    })
}